import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
const db = firebase.firestore()

var cargaCajas = null;
var cargadorCajas = null

const store = {
  state: {
    listaCajas: {},
  },
  getters: {
    listaCajas: state => {
      return state.listaCajas
    },
  },
  mutations: {
    ASIGNA_CATALOGO_CAJAS(state, listaCajas) {
      state.listaCajas = listaCajas
    },
  },
  actions: {
    agregarCaja({ getters }, caja) {
      var idFranquicia = getters.usuario.id_franquicia

      let docPath = db
          .collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(idFranquicia)
          .collection(FS_COLLECTIONS.CATALOGOS)
          .doc(FS_COLLECTIONS.CAJAS)
      return docPath.set(caja)
    },
    cargaCajas({ commit, getters }) {
      return new Promise((resolve, reject) => {
        if (cargadorCajas === null) {

          var idFranquicia = getters.usuario.id_franquicia
        
            let docPath = db
              .collection(FS_COLLECTIONS.FRANQUICIAS)
              .doc(idFranquicia)
              .collection(FS_COLLECTIONS.CATALOGOS)
              .doc(FS_COLLECTIONS.CAJAS)
            cargadorCajas = docPath.onSnapshot(doc => {
              //console.log('Current data cajas: ', doc.data())
              commit('ASIGNA_CATALOGO_CAJAS', doc.data())
              resolve()
            })
        
        } else {
          resolve()
        }
      })
    },
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/cajas/cajas.js